"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreditCardBrands;
(function (CreditCardBrands) {
    CreditCardBrands["VISA"] = "visa";
    CreditCardBrands["MASTERCARD"] = "mastercard";
})(CreditCardBrands = exports.CreditCardBrands || (exports.CreditCardBrands = {}));
